import React from "react";
import '../App.css';
import { FaWhatsapp } from "react-icons/fa";

const LiveChat = () => {
  const whatsappNumber = "94714820101"; // Change to your WhatsApp number (with country code)

  return (
    <a
      href={`https://wa.me/${whatsappNumber}`}
      className="live-chat-button"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp className="whatsapp-icon" />
      Chat with us
    </a>
  );
};

export default LiveChat;
